var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundFlagPt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kw8dk63xoa)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bgc82zv3kb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bgc82zv3kb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73AF00",
    d: "M0 0h8.69v24H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.693,
    cy: 12,
    r: 5.268,
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35 9.07h4.686c.324 0 .586.263.586.587v2.929a2.93 2.93 0 0 1-5.858 0v-2.93c0-.323.262-.585.586-.585zm4.1 3.516v-2.343H6.935v2.343c0 .969.789 1.757 1.758 1.757a1.76 1.76 0 0 0 1.757-1.757z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.934 10.759v1.655c0 .684-.557 1.241-1.241 1.241a1.243 1.243 0 0 1-1.241-1.241v-1.655h2.482",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.345,
    cy: 9.657,
    fill: "#FFE15A",
    r: 0.293
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.032,
    cy: 9.657,
    r: 0.293,
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.345,
    cy: 12,
    fill: "#FFE15A",
    r: 0.293
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.032,
    cy: 12,
    fill: "#FFE15A",
    r: 0.293
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.688,
    cy: 9.657,
    fill: "#FFE15A",
    r: 0.293
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.447,
    cy: 14.16,
    r: 0.293,
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.964,
    cy: 14.16,
    fill: "#FFE15A",
    r: 0.293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.071 11.851v.505a.379.379 0 0 1-.756 0v-.505h.756M9.071 10.655v.505a.379.379 0 0 1-.756 0v-.505h.756M9.071 13.06v.504a.379.379 0 0 1-.756 0v-.504h.756M10.09 11.851v.505a.379.379 0 0 1-.756 0v-.505h.756M8.052 11.851v.505a.379.379 0 0 1-.756 0v-.505h.756",
    fill: "#41479B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kw8dk63xoa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundFlagPt);
export default __webpack_public_path__ + "static/media/round-flag-pt.d40580e98c53e3edbc0dbb63e1956ea2.svg";
export { ForwardRef as ReactComponent };